module.exports = __webpack_public_path__ + "static/scale-model-of-nybg-ticket-counter-in-yonkers-new-york-5619de6c096cb1b0db41279729c0dae3.png";